import movieApi from "./movieDefault";

export default {
  searchMovie({ apiKey, language, searchName }) {
    return movieApi.get(`/search/movie?api_key=${apiKey}&language=${language}&query=${searchName}`);
  },
};
